import React from "react";
/* import LoadingIndicator from "../../utils/LoadingIndicator/LoadingIndicator"; */
import { authUser, authAdmin } from "../../utils/Functions/functions";
import axios from "../../utils/Axios/axiosProxy";
import Tracker from "../../components/Tracker/Tracker";
import "./RequestForm.scss";
import { RequestFormState, defaultRequestFormState } from "./RequestFormState";
import { RequestFormContent } from "./RequestFormContent";

export const RequestFormContext = React.createContext<any>({});

export class RequestForm extends React.Component<{}, RequestFormState> {
  constructor(props: {}) {
    super(props);
    this.state = defaultRequestFormState;
  }

  public getUserAccount = (JWT: string) => {
    axios
      .get("/api/account/id", {
        headers: {
          Authorization: `Bearer ${JWT}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("GET USER RESPONSE: ", response.statusText);
        this.setState({
          userAccount: response.data.account,
          userFetched: true,
          order: {
            ...this.state.order,
            userID: response.data.account.userID,
            contact: {
              ...this.state.order.contact,
              firstname: response.data.account.firstname,
              lastname: response.data.account.lastname,
              email: response.data.account.email,
              phone: response.data.account.phone,
              companyname: response.data.account.companyname,
              taxnr: response.data.account.taxnr,
            },
          },
        });
      })
      .catch((error) => {
        console.log("GET USER ERROR: ", error.response.data);
      })
      .catch((error) => console.log("GET USER FROM DB error", error));
  };

  private setTracker = (track: string, step: number) => {
    if (this.state[track] !== step) {
      this.setState({ [track]: step });
    }
  };

  private resetTracker = (track: string) => {
    if (this.state[track] !== 0) {
      this.setState({ [track]: 0 });
    }
  };

  public componentDidMount() {
    const jwtFromLStorage: string = localStorage.getItem("JWT") as string;
    if (authUser(jwtFromLStorage) && !authAdmin(jwtFromLStorage)) {
      this.setState({ loggedIn: true });
      this.getUserAccount(jwtFromLStorage);
    } /* else if (authUser(jwtFromLStorage) && authAdmin(jwtFromLStorage)) {
      localStorage.removeItem("JWT");
      localStorage.removeItem("token");
      this.setState({ loggedIn: false });
    } */
    if (this.state.activeStep === 0) {
      this.setTracker("cargoDetails", this.state.activeStep + 1);
    }
  }

  public componentDidUpdate() {
    const step: number = this.state.activeStep;

    if (step >= 2 && step <= 11) {
      this.setTracker("serviceInfo", step - 1);
    }

    if (step === 12 || step === 13) {
      this.setTracker("userDetails", step - 11);
    }

    if (step === 0 || step === 1) {
      this.setTracker("cargoDetails", step + 1);
    }

    switch (step) {
      case 1:
        this.resetTracker("serviceInfo");
        break;
      case 11:
        this.resetTracker("userDetails");
        break;
      case 12:
        this.setTracker("serviceInfo", 10);
        break;
      case 13:
        this.setTracker("serviceInfo", 10);
        break;
      default:
        break;
    }
  }

  public submitOrder = () => {
    let data = this.state.order;
    axios
      .post("/api/order", JSON.stringify(data), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("AXIOS RESPONSE: ", response.statusText);
      })
      .catch((error) => {
        console.log("AXIOS ERROR: ", error.response.data);
      })
      .catch((error) => console.log("submitToDB error", error));
  };

  public handleNext = (num: number) => {
    const increase: number = num ?? 1;
    this.setState({ activeStep: this.state.activeStep + increase });
    window.scrollTo(0, 0);
  };

  public handleBack = (num: number) => {
    const decrease: number = num ?? 1;
    this.setState({ activeStep: this.state.activeStep - decrease });
    window.scrollTo(0, 0);
  };

  public addItem = (stateObj: any, item: any) => {
    let tempItem = this.state.order[stateObj];
    if (stateObj === "shipperaddresses" || stateObj === "consigneeaddresses") {
      tempItem[0] = item;
    } else if (
      stateObj !== "shipperaddresses" &&
      stateObj !== "consigneeaddresses"
    ) {
      tempItem.push(item);
    }
    this.setState({
      order: { ...this.state.order, [stateObj]: tempItem },
    });
    return tempItem;
  };

  public removeItem = (stateObj: any, index: number) => {
    let tempItem = this.state.order[stateObj];
    tempItem.splice(index, 1);
    this.setState({
      order: { ...this.state.order, [stateObj]: tempItem },
    });
    if (stateObj === "shipments") {
      this.setState({
        order: {
          ...this.state.order,
          shipmentweight:
            this.calcTotalShipmentWeightAndPcs(tempItem).shipmentweight,
          shipmentchargeableweight:
            this.calcTotalShipmentWeightAndPcs(tempItem)
              .shipmentchargeableweight,
          shipmentpcs: this.calcTotalShipmentWeightAndPcs(tempItem).shipmentpcs,
          shipmentvolume:
            this.calcTotalShipmentWeightAndPcs(tempItem).shipmentvolume,
        },
      });
    }
  };

  public handleItemChange = (event: any, i: number, stateObj: any) => {
    let tempArray = this.state.order[stateObj];
    let tempItem = { ...tempArray[i] };
    tempItem[event.target.id] = event.target.value;
    if (
      stateObj === "shipments" &&
      tempItem.height.length > 0 &&
      tempItem.width.length > 0 &&
      tempItem.length.length > 0 &&
      tempItem.quantity.length > 0 &&
      tempItem.weight.length > 0
    ) {
      tempItem = this.calcShipmentProperties(tempItem);
      tempArray[i] = tempItem;
      this.setState({
        order: {
          ...this.state.order,
          [stateObj]: tempArray,
          shipmentweight:
            this.calcTotalShipmentWeightAndPcs(tempArray).shipmentweight,
          shipmentchargeableweight:
            this.calcTotalShipmentWeightAndPcs(tempArray)
              .shipmentchargeableweight,
          shipmentpcs:
            this.calcTotalShipmentWeightAndPcs(tempArray).shipmentpcs,
          shipmentvolume:
            this.calcTotalShipmentWeightAndPcs(tempArray).shipmentvolume,
        },
      });
    } else {
      tempArray[i] = tempItem;
      this.setState({
        order: {
          ...this.state.order,
          [stateObj]: tempArray,
        },
      });
    }
  };

  public calcShipmentProperties = (shipment: any) => {
    console.log('shipment b4', shipment);
    shipment.actualweight =
      Math.round(
        parseFloat(shipment.weight.replace(/,/, '.')) *
          parseFloat(shipment.quantity) *
          10
      ) / 10;
    shipment.totalvolume =
      Math.round(
        ((parseFloat(shipment.height.replace(/,/, '.')) *
          parseFloat(shipment['length'].replace(/,/, '.')) *
          parseFloat(shipment.width.replace(/,/, '.'))) /
          1000000) *
          parseFloat(shipment.quantity) *
          10
      ) / 10;
    shipment.chargeableweight =
      Math.round(
        ((parseFloat(shipment.height.replace(/,/, '.')) *
          parseFloat(shipment['length'].replace(/,/, '.')) *
          parseFloat(shipment.width.replace(/,/, '.'))) /
          6000) *
          parseFloat(shipment.quantity) *
          10
      ) / 10;
    console.log('shipment', shipment);
    return shipment;
  };
  public calcTotalShipmentWeightAndPcs = (shipments: any) => {
    let totalchargeableweight: number = 0;
    let totalactualweight: number = 0;
    let totalpieces: number = 0;
    let totalvolume: number = 0;
    shipments.forEach((shipment: any) => {
      totalchargeableweight += shipment.chargeableweight;
      totalactualweight += shipment.actualweight;
      totalvolume += shipment.totalvolume;
      if (shipment.quantity.length > 0) {
        totalpieces += parseFloat(shipment.quantity);
      }
    });
    return {
      shipmentweight: totalactualweight,
      shipmentchargeableweight:
        totalchargeableweight > totalactualweight
          ? totalchargeableweight
          : totalactualweight,
      shipmentpcs: totalpieces,
      shipmentvolume: totalvolume,
    };
  };

  public handleChange = (stateObj: any, value: any) => {
    this.setState({
      order: { ...this.state.order, [stateObj]: value },
    });
  };

  public handleCheck = (event: any) => {
    this.setState({
      order: { ...this.state.order, [event.target.id]: event.target.checked },
    });
  };

  public handleContact = (event: any) => {
    let value = event.target.value;
    if (event.target.id === "email") {
      value = value.toLowerCase();
    }
    this.setState({
      order: {
        ...this.state.order,
        contact: {
          ...this.state.order.contact,
          [event.target.id]: value,
        },
      },
    });
  };
  public setLoggedIn = () => {
    this.setState({ loggedIn: true });
  };
  render() {
    return (
      <RequestFormContext.Provider value={this}>
        <div className="FormContainer Background">
          {/* <Header /> */}
          <div className="TrackerContainer FormWidth">
            {/*  SPACE FOR STEPPER */}
            <div className="Flex1">
              <Tracker
                steps={3}
                id="cargo"
                activeStep={this.state.cargoDetails}
              />
            </div>
            <div className="Flex1">
              <Tracker
                steps={11}
                id="serviceinfo"
                activeStep={this.state.serviceInfo}
              />
            </div>
            {this.state.loggedIn ? (
              <></>
            ) : (
              <div className="Flex1">
                <Tracker
                  steps={3}
                  id="details"
                  activeStep={this.state.userDetails}
                />
              </div>
            )}
          </div>
          <div className="FormContentContainer">
            <RequestFormContent step={this.state.activeStep} />
          </div>
        </div>
      </RequestFormContext.Provider>
    );
  }
}
